import React from 'react'

import { api } from 'core/api/ConnectionManager'
import { mediaJS } from 'theme'
import { getParamsForLink } from 'core/helpers/user'
import { IFile } from '../../../core/models/Files'
const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
const removeEventMethod = window.addEventListener ? 'removeEventListener' : 'detachEvent'
// @ts-ignore
const eventer = window[eventMethod]
// @ts-ignore
const removeEventer = window[removeEventMethod]
const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'
const WIDGET_EDITOR__SELECT_MEDIA = 'widgetEditor__selectMedia'
const WIDGET_EDITOR__SELECT_MEDIA_WITH_FOLDERS = 'widgetEditor__selectMediaWithFolders'
const WIDGET_EDITOR__SELECT_MEDIA_BY_FIELDS = 'widgetEditor__selectMediaBYFields'
const WIDGET_EDITOR__SELECT_MEDIA_WITH_FOLDERS__WITH_ID = 'widgetEditor__selectMediaWithFolders__id'
const allowedFileTypes = ['image', 'video', 'audio', 'office']

const isNoisePostMessage = (parsed: unknown) => {
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return true
    }
    const keys = Object.keys(parsed as object)
    if (keys.length === 0) {
        return true
    }
    if (keys.length === 1 && (keys[0] === 'type' || keys[0] === '__type')) {
        return true
    }
    if (keys.length === 2 && keys.includes('type') && keys.includes('__type')) {
        return true
    }
    return false
}

const isAcceptableWidgetPayload = (parsed: unknown) => !isNoisePostMessage(parsed)

type State = {
    type: string
    text: string | null
    webAppPreviewURL: string | null
    width: number
    height: number
    data: any
    dimensions: {
        width?: number
        height?: number
    }
    loadingData: boolean
    showSettingsOnMobile: boolean
    selectMediaId: string
}

type Item = {
    id: number
    src: string
    fileType: string
    name: string
    folderId: number
    data: string
    isDirectory: number
} | null

interface IPreviewWebAppProps {
    item: Partial<Item>
    emitError: (err: string) => void
    tokens?: {
        accessToken: string
        refreshToken: string
    }
    isEditable?: boolean
    mainUser?: { id: number }
    user?: { id: number }
    onClose?: () => void
    locale?: string
    width?: number
    height?: number
    indents?: string
}

class PreviewWebAppMethods extends React.Component<IPreviewWebAppProps> {
    listenersId = []
    selectContent: any = null
    webAppPreview: any = null
    state: State = {
        text: null,
        webAppPreviewURL: null,
        width: 1920,
        height: 1080,
        data: null,
        dimensions: {},
        loadingData: false,
        showSettingsOnMobile: false,
        selectMediaId: '',
        type: '',
    }

    onWebAppPreviewUrlCreated = ({ sourceId, webAppPreviewURL }: { sourceId: number; webAppPreviewURL: string }) => {
        const p_ = this.props

        if (p_.item && sourceId !== p_.item.id) {
            return false
        }

        this.setState({ webAppPreviewURL: this.getPreviewUrl(webAppPreviewURL) })
    }

    onWebAppBuildingStatusChanged = ({
        sourceId,
        webAppBuilding,
    }: {
        sourceId: number
        webAppBuilding: { status: string }
    }) => {
        const p_ = this.props

        if (p_.item && sourceId !== p_.item.id) {
            return false
        }

        if (webAppBuilding.status === 'in_progress') {
            this.setState({ loadingData: true })
        } else if (webAppBuilding.status === 'error') {
            p_.emitError('webAppBuildingError')
            this.setState({ loadingData: false, webAppPreviewURL: null })
        } else {
            this.setState({ loadingData: false, webAppPreviewURL: null })
            api.send('getWebAppPreviewUrl', { sourceId: p_.item ? p_.item.id : null }).then(
                ({ webAppPreviewURL }: any) => {
                    this.setState({ webAppPreviewURL: this.getPreviewUrl(webAppPreviewURL) })
                }
            )
        }
    }

    componentDidMount() {
        const p_ = this.props
        this.initPreview(p_)

        api.addObserver('webAppPreviewUrlCreated', this.onWebAppPreviewUrlCreated, this.listenersId)
        api.addObserver('webAppBuildingStatusChanged', this.onWebAppBuildingStatusChanged, this.listenersId)

        eventer(messageEvent, this.getData, false)
    }
    componentDidUpdate(prevProps: IPreviewWebAppProps) {
        const p_ = this.props

        if (p_.item && p_.item.id !== prevProps!.item!.id) {
            this.setState(
                {
                    text: null,
                    webAppPreviewURL: null,
                    data: null,
                    dimensions: {},
                    loadingData: null,
                },
                () => {
                    this.initPreview(p_)
                }
            )
        }
    }
    componentWillUnmount() {
        this.listenersId.forEach((id) => api.removeObserver(id))

        removeEventer(messageEvent, this.getData, false)
    }
    getPreviewUrl = (baseUrl: string) => {
        const p_ = this.props
        const params =
            p_.tokens && p_.mainUser && p_.user ? getParamsForLink(p_.tokens, p_.mainUser.id, p_.user.id) : {}
        const url = `${baseUrl}?${params}`

        return p_.isEditable ? `${url}&editWidget` : url
    }
    onlyUnique = (value: any, index: number, array: any) => {
        return array.indexOf(value) === index
    }
    initPreview = (p_: IPreviewWebAppProps) => {
        api.send('getFile', { id: p_.item!.id }).then(({ data }: any) => {
            const loadingData = data.webAppBuilding && data.webAppBuilding.status === 'in_progress'
            const state = {
                loadingData,
                showSettingsOnMobile: false,
            }

            //TODO: Убрать логику с showSettingsOnMobile когда все виджеты перейдут на эту логику

            if (data.widgetInfo && data.widgetInfo.showSettingsOnMobile && mediaJS.tabMini.matches) {
                state.showSettingsOnMobile = true
            }

            this.setState({
                ...state,
            })

            api.send('getWebAppPreviewUrl', { sourceId: p_.item!.id }).then(({ webAppPreviewURL, status }: any) => {
                if (status === 'success') {
                    this.setState({ webAppPreviewURL: this.getPreviewUrl(webAppPreviewURL) })
                }
            })
        })
    }
    getData = (event: MessageEvent) => {
        const data = event.data
        const iframeWindow = this.webAppPreview?.contentWindow as Window | null | undefined
        const fromWidgetIframe = Boolean(iframeWindow && event.source === iframeWindow)

        let type = ''
        let _data: string = ''

        if (typeof data === 'string') {
            const messageWithType = data.includes('__type=') ? data.split('__type=') : ['']
            type = messageWithType[1] || ''
            _data = type ? messageWithType[0] : data
        } else if (data && typeof data === 'object') {
            type = (data.__type || data.type || '') as string
            _data = JSON.stringify(data)
        } else {
            _data = String(data)
        }

        const isSelectMedia =
            _data === WIDGET_EDITOR__SELECT_MEDIA ||
            _data === WIDGET_EDITOR__SELECT_MEDIA_WITH_FOLDERS ||
            _data.includes(WIDGET_EDITOR__SELECT_MEDIA_WITH_FOLDERS__WITH_ID) ||
            _data.includes(WIDGET_EDITOR__SELECT_MEDIA_BY_FIELDS)

        if (isSelectMedia) {
            if (!fromWidgetIframe) {
                return
            }

            if (_data.includes(WIDGET_EDITOR__SELECT_MEDIA_BY_FIELDS)) {
                const dataList = JSON.parse(_data.replace(WIDGET_EDITOR__SELECT_MEDIA_BY_FIELDS + '__', ''))
                const sourceId = dataList
                    .map((item: { field: string; sourceId: number }) => {
                        return item.sourceId
                    })
                    .filter(this.onlyUnique)
                const dataToSend: {
                    field: string
                    data: {
                        id: number
                        src: string
                        '$download:src': string
                        type: string
                        name: string
                    }[]
                }[] = []

                api.send('getSources', { sourceId }).then((res: any) => {
                    if (res) {
                        dataList.forEach((item: { field: string; sourceId: number }) => {
                            const source = res.find((source: IFile) => source.id === item.sourceId)

                            if (source) {
                                dataToSend.push({
                                    field: item.field,
                                    data: [
                                        {
                                            id: source.id,
                                            src: source!.src,
                                            '$download:src': source!.src,
                                            type: source!.fileType,
                                            name: source!.name,
                                        },
                                    ],
                                })
                            }
                        })
                    }

                    this.webAppPreview.contentWindow.postMessage(
                        `selectMediaBYFields__${JSON.stringify(dataToSend)}`,
                        '*'
                    )
                })

                return
            }

            if (_data.includes(WIDGET_EDITOR__SELECT_MEDIA_WITH_FOLDERS__WITH_ID)) {
                const id = _data.replace(WIDGET_EDITOR__SELECT_MEDIA_WITH_FOLDERS__WITH_ID + '=', '')
                this.setState({ selectMediaId: id })
            }

            this.onOpenModalCatalogContent(allowedFileTypes.includes(type) ? type : '')
            return
        }

        let parsed: any = null
        try {
            parsed = JSON.parse(_data)
        } catch (e) {
            return
        }

        if (!fromWidgetIframe || !isAcceptableWidgetPayload(parsed)) {
            return
        }

        this.setState({ data: _data, type }, () => {
            const p_ = this.props
            const s_ = this.state

            if (s_.showSettingsOnMobile && p_.isEditable) {
                this.save(p_.onClose ? p_.onClose : () => {})
            }
        })
    }

    onOpenModalCatalogContent = (type: string) => {
        if (this.selectContent) {
            this.selectContent.openModal(null, type)
        }
    }

    iframeOnLoad = () => {
        const { tokens } = this.props

        const data = JSON.stringify({
            host: window.spconfig.ip_address,
            token: tokens ? tokens.accessToken : '',
        })

        this.webAppPreview.contentWindow.postMessage(`authorization__${data}`, '*')
        this.setSettingsToWidget()
    }

    setSettingsToWidget = () => {
        const p_ = this.props
        const s_ = this.state

        if (!p_.isEditable) {
            return
        }

        const locale = p_.locale

        const settings = JSON.stringify({
            showSettingsOnMobile: s_.showSettingsOnMobile,
            locale,
        })

        this.webAppPreview.contentWindow.postMessage(`settings__${settings}`, '*')
    }

    onSelectCatalogContent = (item: Item) => {
        if (item) {
            if (item.isDirectory) {
                api.send('getSources', { folderId: item.id })
                    .then((res: any) => {
                        return res.map((source: Item) => ({
                            id: source!.id,
                            src: source!.src,
                            type: source!.fileType,
                            name: source!.name,
                            folderId: source!.folderId,
                            data: source!.data,
                        }))
                    })
                    .then((fileSources) => {
                        if (this.state.data === WIDGET_EDITOR__SELECT_MEDIA_WITH_FOLDERS) {
                            api.send('getFolder', { folderId: item.id }).then((res: any) => {
                                let folders = this._getFoldersOnly(res.content)
                                const filesWithFolders = {
                                    files: fileSources,
                                    folders,
                                }

                                this.webAppPreview.contentWindow.postMessage(
                                    `selectMediaWithFolders__${JSON.stringify(filesWithFolders)}`,
                                    '*'
                                )
                            })
                            return
                        }

                        this.webAppPreview.contentWindow.postMessage(
                            `${
                                this.state.selectMediaId
                                    ? `selectMediaWithId=${this.state.selectMediaId}__`
                                    : 'selectMedia__'
                            }${JSON.stringify(fileSources)}`,
                            '*'
                        )

                        this.setState({ selectMediaId: '' })
                    })

                return
            }

            this.webAppPreview.contentWindow.postMessage(
                `selectMedia__${JSON.stringify({
                    id: item.id,
                    src: item.src,
                    type: item.fileType,
                    name: item.name,
                    data: item.data,
                })}`,
                '*'
            )
        }
    }

    _getFoldersOnly = (contents: { isDirectory: number }[]) => {
        let folders: any = []
        if (contents && Array.isArray(contents)) {
            folders = contents.filter((content) => content.isDirectory === 1)
        }
        return folders
    }

    save = (callback: () => void) => {
        const s_ = this.state
        const p_ = this.props

        if (!s_.data) {
            callback()
            return
        }

        try {
            const data = JSON.parse(s_.data)

            if (!isAcceptableWidgetPayload(data)) {
                console.error('[webAppPreview] refuse to save noise payload', data)
                callback()
                return
            }

            const dataToUpdate = {
                sourceId: p_.item ? p_.item.id : null,
                data,
            }
            const { tokens } = this.props

            fetch(`${window.spconfig.ip_address}source/v1/update-web-app`, {
                method: 'POST',
                body: JSON.stringify(dataToUpdate),
                headers: new Headers({
                    Authorization: `Bearer ${tokens?.accessToken}` || '',
                    'Content-Type': 'application/json',
                }),
            })
                .then((response) => {
                    if (!response.ok) {
                        console.error('[webAppPreview] update-web-app failed', response.status)
                        p_.emitError('webAppBuildingError')
                        return
                    }

                    if (!(s_.showSettingsOnMobile && p_.isEditable)) {
                        this.setState({ loadingData: true })
                    }

                    callback()
                })
                .catch((error) => {
                    console.error('[webAppPreview] update-web-app network error', error)
                    p_.emitError('webAppBuildingError')
                })

            // api.send('updateWebApp', dataToUpdate).then(() => {
            //     if (s_.showSettingsOnMobile && p_.isEditable) {
            //         return
            //     }

            //     this.setState({ loadingData: true })
            // })

            return
        } catch (e) {
            console.error('[webAppPreview] save parse error', e)
        }

        callback()
    }
}

export default PreviewWebAppMethods
